// AhorrosWrapper.jsx
import React, { useContext } from 'react';
import { AuthContext } from '../App';
import Ahorros from './Ahorros';          // versión admin (existente)
import AhorrosCli from './AhorrosCli';    // versión cliente (nueva)

export default function AhorrosWrapper() {
  const { user } = useContext(AuthContext);

  const isAdmin  = user?.permisos === 1;
  const isClient = user?.permisos === 5;

  if (isAdmin) {
    return <Ahorros />;
  }

  if (isClient) {
    return <AhorrosCli />;
  }

  // Cualquier otro rol no tiene acceso
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-lg p-12 border border-gray-100 text-center max-w-md">
        <div className="p-6 rounded-full w-24 h-24 mx-auto mb-6 flex items-center justify-center bg-red-100">
          <span className="text-4xl">🚫</span>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Acceso Denegado</h2>
        <p className="text-gray-600 leading-relaxed">
          No tienes permisos para acceder a la sección de Ahorros.
          Contacta con el administrador para obtener acceso.
        </p>
        <div className="mt-6 text-sm text-gray-500">
          Tu nivel de permisos: {user?.permisos ?? 'No definido'}
        </div>
      </div>
    </div>
  );
}